import {
  SET_VALID_TOKEN,
  SET_VALID_PHONE,
  SET_VALID_OTP,
} from "@/stores/mutations";

import JwtService from "@/jwt-service";

export const mutations = {
  [SET_VALID_TOKEN](state) {
    state.isAuthenticate = true;
  },
  [SET_VALID_PHONE](state, data) {
    JwtService.saveCustomerPhone(data.phone_number);
    state.phone_number = data.phone_number;
    state.isPhoneValid = true;
  },
  [SET_VALID_OTP](state, data) {
    JwtService.saveToken(data.token);
    state.isAuthenticate = true;
  },
};
